var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "dialog" } },
    [
      _c("div", {
        staticClass: "vo-scrim",
        class: { active: _vm.showing, disabled: _vm.lockout, modal: _vm.modal },
        on: {
          click: function($event) {
            _vm.showing = false
          }
        }
      }),
      _vm._v(" "),
      _c("transition", { attrs: { name: "grow" } }, [
        _vm.showing
          ? _c("div", { staticClass: "center-parent" }, [
              _c(
                "div",
                { staticClass: "dialog-box" },
                [
                  _c(
                    "div",
                    { staticClass: "header" },
                    [
                      _c("div", { staticClass: "item-title" }, [
                        _vm._v(_vm._s(_vm.params.title))
                      ]),
                      _vm._v(" "),
                      !_vm.modal
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "vo-icon-button",
                              attrs: {
                                disabled: _vm.lockout,
                                fab: "",
                                flat: "",
                                small: ""
                              },
                              on: {
                                click: function($event) {
                                  _vm.showing = false
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { medium: "" } }, [
                                _vm._v("mdi-close")
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.params.body
                    ? _c("div", { staticClass: "body" }, [
                        _vm._v(_vm._s(_vm.params.body))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.params.html
                    ? _c("div", {
                        staticClass: "body",
                        domProps: { innerHTML: _vm._s(_vm.params.html) }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.component
                    ? _c(_vm.component, {
                        ref: "componentRef",
                        tag: "component",
                        staticClass: "body"
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "footer-box" }, [
                    _c(
                      "div",
                      { staticClass: "buttons" },
                      [
                        !_vm.modal
                          ? _c(
                              "v-btn",
                              {
                                attrs: {
                                  flat: "",
                                  color: "info",
                                  disabled: _vm.lockout
                                },
                                on: { click: _vm.dismiss }
                              },
                              [_vm._v(_vm._s(_vm.params.dismiss.title))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.params.confirm &&
                        _vm.params.confirm.title &&
                        (_vm.params.confirm.action || _vm.params.component)
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "confirm",
                                attrs: {
                                  flat: "",
                                  color: "primary",
                                  loading: _vm.lockout
                                },
                                on: { click: _vm.confirm }
                              },
                              [_vm._v(_vm._s(_vm.params.confirm.title))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "clear" })
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd1e8110", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd1e8110","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dialog.vue
// module id = 464
// module chunks = 4